import { Category } from './category'
import { Firm } from './firm'
import { Listing } from './listing'
import { Metadata } from './metadata'

export interface Product {
    listing: Listing
    metadata: Partial<Metadata>
    imageUrl?: string
    productType: string
    sectionName: string
    description?: string
    name?: string
    firm: Partial<Firm>
}

export interface ProductResponse {
    allProducts: Category[]
}

export interface ManufacturerProductBimLinkDetail {
    bimUrl: string
    imageUrl: string
    productDescription: string
    productName: string
}

export interface ManufacturerProductCatalogDetail {
    path: string
    thumbnailPath: string
    title: string
    uploadedDate: string
}

export enum ListingLevel {
    PremiumMasterSpec = 'Premium MasterSpec',
    Premium = 'Premium',
    PremiumProprietary = 'Premium Proprietary',
    Manufacturer = 'Manufacturer',
    Product = 'Product',
    ProductListing = "Product Listing",
    None = 'None',
}

export interface ManufacturerProductImageDetail {
    filename: string
    isPrimary: boolean
    id: string
    order: number
    originalFilename: string
}

export interface ManufacturerProductSpecDocDetail {
    docType: string
    docVariation: string
    expirationDate: string
    id: string
    path: string
    title: string
}

export interface ManufacturerProductVideoDetail {
    fromSource: string
    id: string
    order: number
    videoId: string
    videoStillImageUrl: string
}

export interface ManufacturerProductWebLinkDetail {
    order: number
    type: string
    url: string
}

export interface ManufacturerProductPropertyDetail {
    isPremiumPlus?: boolean
    options: Partial<ManufacturerProductPropertyOptionDetail>[]
    optionGroups: Partial<ManufacturerProductPropertyOptionGroupDetail>[]
    propertyId: string
    propertyName: string
    subPropertyName?: string
    originalPropertyName: string
}

export interface ManufacturerProductPropertyOptionGroupDetail {
    groupId: string
    prefix: string
    postfix: string
    options: Partial<ManufacturerProductPropertyOptionDetail>[]
}

export interface ManufacturerProductPropertyOptionDetail {
    isOther: boolean
    isPremium: boolean
    isPremiumPlus?: boolean
    isSupported: boolean
    optionId: string
    value: string
    isUnitOfMeasure: boolean
    imperialUnits: string
    metricUnits: string
    isInlineTextOnly?: boolean
}

export interface ManufacturerProductListingProductTypePropertyDetail {
    categories: string[]
    properties: Partial<ManufacturerProductPropertyDetail>[]
}

export interface Partnership {
    level: string
    name: string
    partnerType: string
    url: string
}

export interface ManufacturerProductUserDetail {
    emailAddress: string
    id: string
}
